import * as React from 'react';
import { Route } from 'react-router-dom';

import { IRoute } from '../interface';

const RouteWithSubRoutes = (routeProps: IRoute) => {
  return (
    <Route
      path={routeProps.path}
      exact={routeProps.exact}
      render={(props) => {
        return <routeProps.component routes={routeProps.routes} {...props} />;
      }}
    />
  );
};

export default RouteWithSubRoutes;



// WEBPACK FOOTER //
// ./src/utils/route.tsx